import { LANGUAGES } from '../constants/languages';
import getWordForm, { WORD_FORMS } from '../helpers/getWordForm';

export const DICTIONARY = {
  some: {
    [LANGUAGES.ru.code]: () => '',
    [LANGUAGES.en.code]: () => '',
  },
  serverErrorTitle: {
    [LANGUAGES.ru.code]: () => 'ОШИБКА СЕРВЕРА',
    [LANGUAGES.en.code]: () => 'SERVER ERROR',
  },
  serverErrorText: {
    [LANGUAGES.ru.code]: () => 'Попробуйте чуть позже',
    [LANGUAGES.en.code]: () => 'Try later',
  },
  siteTitle: {
    [LANGUAGES.ru.code]: () => 'Конфигуратор AIG',
    [LANGUAGES.en.code]: () => 'AIG Configurator',
  },
  siteDescription: {
    [LANGUAGES.ru.code]: () => 'Онлайн-инструмент расчета характеристик стеклоизделий для профессионалов строительной отрасли',
    [LANGUAGES.en.code]: () => 'Online tool for calculating glass products characteristics for construction industry professionals',
  },
  ok: {
    [LANGUAGES.ru.code]: () => 'Ок',
    [LANGUAGES.en.code]: () => 'Ok',
  },
  cancel: {
    [LANGUAGES.ru.code]: () => 'Отмена',
    [LANGUAGES.en.code]: () => 'Cancel',
  },
  sureToChangeLanguageConfiguration: {
    [LANGUAGES.ru.code]: () => 'При смене языка конфигурация сбросится. Вы уверены, что хотите изменить язык?',
    [LANGUAGES.en.code]: () => 'Changing the language will reset the configuration. Are you sure you want to change it?',
  },
  sureToLogOut: {
    [LANGUAGES.ru.code]: () => 'Вы уверены, что хотите выйти из аккаунта?',
    [LANGUAGES.en.code]: () => 'Are you sure you want to log out of your account?',
  },
  setConfigurationPlaceholder: {
    [LANGUAGES.ru.code]: () => 'Например: 6-14-4-14-44.2 или 6/14/4/14/44.2',
    [LANGUAGES.en.code]: () => 'E.g.: 6-14-4-14-44.2 or 6/14/4/14/44.2',
  },
  askToEditPassword: {
    [LANGUAGES.ru.code]: () => 'Необходимо задать свой пароль',
    [LANGUAGES.en.code]: () => 'You must set your password',
  },
  passwordsNotMatch: {
    [LANGUAGES.ru.code]: () => 'Пароли не совпадают',
    [LANGUAGES.en.code]: () => 'Passwords don’t match',
  },
  noNumber: {
    [LANGUAGES.ru.code]: () => 'Отсутствует цифра (0-9)',
    [LANGUAGES.en.code]: () => 'Please add numbers (0-9)',
  },
  noUpperCase: {
    [LANGUAGES.ru.code]: () => 'Отсутствует заглавная буква (A-Z)',
    [LANGUAGES.en.code]: () => 'Please add uppercase letters (A-Z)',
  },
  noLowerCase: {
    [LANGUAGES.ru.code]: () => 'Отсутствует строчная буква (a-z)',
    [LANGUAGES.en.code]: () => 'Please add lowercase letters (a-z)',
  },
  noNonAlphanumeric: {
    [LANGUAGES.ru.code]: () => 'Отсутствует специальный символ (!@#$%^&*...)',
    [LANGUAGES.en.code]: () => 'Please add special symbol (!@#$%^&*...)',
  },
  profileSaved: {
    [LANGUAGES.ru.code]: () => 'Личные данные успешно сохранены!',
    [LANGUAGES.en.code]: () => 'Profile data was successfully saved!',
  },
  nameRequired: {
    [LANGUAGES.ru.code]: () => 'Введите ФИО',
    [LANGUAGES.en.code]: () => 'Please enter your full name',
  },
  emailRequired: {
    [LANGUAGES.ru.code]: () => 'Введите e-mail',
    [LANGUAGES.en.code]: () => 'Please enter your e-mail',
  },
  topicRequired: {
    [LANGUAGES.ru.code]: () => 'Введите тему',
    [LANGUAGES.en.code]: () => 'Please enter the topic',
  },
  requestRequired: {
    [LANGUAGES.ru.code]: () => 'Введите текст запроса',
    [LANGUAGES.en.code]: () => 'Please enter the request text',
  },
  phoneRequired: {
    [LANGUAGES.ru.code]: () => 'Введите номер телефона',
    [LANGUAGES.en.code]: () => 'Please enter your phone number',
  },
  companyRequired: {
    [LANGUAGES.ru.code]: () => 'Введите название компании',
    [LANGUAGES.en.code]: () => 'Please enter your company\'s name',
  },
  positionRequired: {
    [LANGUAGES.ru.code]: () => 'Введите должность',
    [LANGUAGES.en.code]: () => 'Please enter your position',
  },
  policyRequired: {
    [LANGUAGES.ru.code]: () => 'Вам необходимо ознакомиться с политикой конфиденциальности',
    [LANGUAGES.en.code]: () => 'You are required to read the privacy policy',
  },
  acceptTerms: {
    [LANGUAGES.ru.code]: () => 'Принять условия',
    [LANGUAGES.en.code]: () => 'Accept the terms',
  },
  back: {
    [LANGUAGES.ru.code]: () => 'Назад',
    [LANGUAGES.en.code]: () => 'Back',
  },
  next: {
    [LANGUAGES.ru.code]: () => 'Дальше',
    [LANGUAGES.en.code]: () => 'Next',
  },
  tutorials: {
    stage1: {
      step1: {
        [LANGUAGES.ru.code]: () => 'Выберите готовый шаблон конфигурации',
        [LANGUAGES.en.code]: () => 'Select the configuration template',
      },
      step2: {
        [LANGUAGES.ru.code]: () => 'Или добавьте компоненты вручную',
        [LANGUAGES.en.code]: () => 'Or add components manually',
      },
      step3: {
        [LANGUAGES.ru.code]: () => 'Или введите конфигурацию в поле',
        [LANGUAGES.en.code]: () => 'Or enter the configuration in the field',
      },
      step4: {
        [LANGUAGES.ru.code]: () => 'Создадим конфигурацию вместе?',
        [LANGUAGES.en.code]: () => 'Let\'s create the configuration together?',
      },
    },
    stage2: {
      step1: {
        [LANGUAGES.ru.code]: () => 'Выберите готовый шаблон конфигурации',
        [LANGUAGES.en.code]: () => 'Select the configuration template',
      },
      step2: {
        [LANGUAGES.ru.code]: () => 'Добавьте покрытие',
        [LANGUAGES.en.code]: () => 'Add the coating',
      },
      step3: {
        [LANGUAGES.ru.code]: () => 'Добавьте покрытие из выпадающего списка',
        [LANGUAGES.en.code]: () => 'Add the coating from the dropdown list',
      },
      step4: {
        [LANGUAGES.ru.code]: () => 'Перетащите покрытие в рабочую область',
        [LANGUAGES.en.code]: () => 'Drag the coating to the workspace',
      },
      step5: {
        [LANGUAGES.ru.code]: () => 'Нажмите на стекло и измените тип термической обработки',
        [LANGUAGES.en.code]: () => 'Click on the glass and change the type of heat treatment',
      },
      step8: {
        [LANGUAGES.ru.code]: () => 'Нажмите «Изменить», чтобы сохранить изменения',
        [LANGUAGES.en.code]: () => 'Click "Edit" to save your changes',
      },
      step9: {
        [LANGUAGES.ru.code]: () => 'Запустите расчет',
        [LANGUAGES.en.code]: () => 'Run the calculation',
      },
      step10: {
        [LANGUAGES.ru.code]: () => 'Сохраните конфигурацию в pdf',
        [LANGUAGES.en.code]: () => 'Save the configuration to pdf',
      },
      step11: {
        [LANGUAGES.ru.code]: () => 'Или отправьте на e-mail',
        [LANGUAGES.en.code]: () => 'Or send by e-mail',
      },
      step12: {
        [LANGUAGES.ru.code]: () => 'Конфигурация автоматически сохраняется в Истории конфигураций, но Вы также можете сохранить ее в разделе Мои проекты',
        [LANGUAGES.en.code]: () => 'The configuration is automatically saved in the Configuration history, but you can also save it in the My projects section',
      },
    },
  },
  error: {
    [LANGUAGES.ru.code]: () => 'Ошибка',
    [LANGUAGES.en.code]: () => 'Error',
  },
  emailSuccess: {
    [LANGUAGES.ru.code]: () => 'Файл успешно отправлен на Ваш e-mail',
    [LANGUAGES.en.code]: () => 'The file was successfully sent to your email',
  },
  cannotCalculate: {
    [LANGUAGES.ru.code]: (count) => `Невозможно выполнить расчет, пока присутствуют ошибки (${count})`,
    [LANGUAGES.en.code]: (count) => `It is impossible to make calculations while there are errors (${count})`,
  },
  chooseProject: {
    [LANGUAGES.ru.code]: () => 'Выберите проект',
    [LANGUAGES.en.code]: () => 'Choose project',
  },
  configurationName: {
    [LANGUAGES.ru.code]: () => 'Название конфигурации',
    [LANGUAGES.en.code]: () => 'Configuration name',
  },
  project: {
    [LANGUAGES.ru.code]: () => 'Проект',
    [LANGUAGES.en.code]: () => 'Project',
  },
  sureToDelete: {
    [LANGUAGES.ru.code]: (count) => `Вы уверены, что хотите удалить выбранные (${count}) элементы?`,
    [LANGUAGES.en.code]: (count) => `Are you sure you want to delete the selected (${count}) items?`,
  },
  sureToDeleteProject: {
    [LANGUAGES.ru.code]: () => 'Вы уверены, что хотите удалить проект?',
    [LANGUAGES.en.code]: () => 'Are you sure you want to delete the project?',
  },
  sureToDeleteConfiguration: {
    [LANGUAGES.ru.code]: () => 'Вы уверены, что хотите удалить конфигурацию?',
    [LANGUAGES.en.code]: () => 'Are you sure you want to delete the configuration?',
  },
  sureToDeleteConfigurations: {
    [LANGUAGES.ru.code]: () => 'Вы уверены, что хотите удалить выбранные конфигурации?',
    [LANGUAGES.en.code]: () => 'Are you sure you want to delete the selected configurations?',
  },
  sureToDetachConfiguration: {
    [LANGUAGES.ru.code]: () => 'Вы уверены, что хотите отвязать конфигурацию от проекта?',
    [LANGUAGES.en.code]: () => 'Are you sure you want to detach the configuration from the selected project?',
  },
  sureToDetachConfigurations: {
    [LANGUAGES.ru.code]: () => 'Вы уверены, что хотите отвязать конфигурации от проектов?',
    [LANGUAGES.en.code]: () => 'Are you sure you want to detach the configurations from the selected projects?',
  },
  changePageWarning: {
    [LANGUAGES.ru.code]: () => 'При переходе выбор элементов будет сброшен',
    [LANGUAGES.en.code]: () => 'If you switch, the selection of items will be reset',
  },
  configurations: {
    [LANGUAGES.ru.code]: (count) => getWordForm(count, WORD_FORMS.configuration),
    [LANGUAGES.en.code]: (count) => (count === 1 ? 'configuration' : 'configurations'),
  },
  minimum2symbols: {
    [LANGUAGES.ru.code]: () => 'Минимум 2 символа',
    [LANGUAGES.en.code]: () => 'Minimum 2 symbols',
  },
  minimum8symbols: {
    [LANGUAGES.ru.code]: () => 'Минимум 8 символов',
    [LANGUAGES.en.code]: () => 'Minimum 8 symbols',
  },
  newProjectName: {
    [LANGUAGES.ru.code]: () => 'Название нового проекта',
    [LANGUAGES.en.code]: () => 'Name of the new project',
  },
  newProject: {
    [LANGUAGES.ru.code]: () => 'Новый проект',
    [LANGUAGES.en.code]: () => 'New project',
  },
  anglesMore: {
    [LANGUAGES.ru.code]: (count) => `Еще ${count}`,
    [LANGUAGES.en.code]: (count) => `${count} more`,
  },
  setAngle: {
    [LANGUAGES.ru.code]: () => 'Введите угол',
    [LANGUAGES.en.code]: () => 'Enter the angle',
  },
  angleMain: {
    [LANGUAGES.ru.code]: () => '90° (базовый)',
    [LANGUAGES.en.code]: () => '90° (main)',
  },
  chooseAngles: {
    [LANGUAGES.ru.code]: () => 'Выберите углы',
    [LANGUAGES.en.code]: () => 'Choose angles',
  },
  anglesHint: {
    [LANGUAGES.ru.code]: () => 'Выберите углы наклона',
    [LANGUAGES.en.code]: () => 'Choose tilt angles',
  },
  configurationCodeHint: {
    [LANGUAGES.ru.code]: () => 'Введите конфигурацию при помощи короткого текстового скретч-кода, разделяя элементы символом "-" или "/". Для задания акустического многослойного стекла введите текст в формате 44.2ac',
    [LANGUAGES.en.code]: () => 'Enter the configuration using a text scratch code separating the elements with the "-" or "/" symbol. To specify acoustic laminated glass, enter text in the format 44.2ac',
  },
  glassHint: {
    [LANGUAGES.ru.code]: () => 'Выберите базовое стекло для создания конфигурации с помощью скретч-кода',
    [LANGUAGES.en.code]: () => 'Select the base glass to create the configuration using the scratch code',
  },
  searchComponents: {
    [LANGUAGES.ru.code]: () => 'Поиск компонентов...',
    [LANGUAGES.en.code]: () => 'Component search...',
  },
  sureToCleanConfiguration: {
    [LANGUAGES.ru.code]: () => 'Вы уверены, что хотите сбросить конфигурацию?',
    [LANGUAGES.en.code]: () => 'Are you sure you want to reset the configuration?',
  },
  setRegion: {
    [LANGUAGES.ru.code]: () => 'Введите регион',
    [LANGUAGES.en.code]: () => 'Enter the region',
  },
  setCityName: {
    [LANGUAGES.ru.code]: () => 'Введите название города',
    [LANGUAGES.en.code]: () => 'Enter the name of the city',
  },
  citySearch: {
    [LANGUAGES.ru.code]: () => 'Поиск города...',
    [LANGUAGES.en.code]: () => 'City search...',
  },
  selectCity: {
    [LANGUAGES.ru.code]: () => 'Выберите город',
    [LANGUAGES.en.code]: () => 'Select city',
  },
  anotherCity: {
    [LANGUAGES.ru.code]: () => 'Другой город',
    [LANGUAGES.en.code]: () => 'Another city',
  },
  notePlaceholder: {
    [LANGUAGES.ru.code]: () => 'Введите примечание',
    [LANGUAGES.en.code]: () => 'Enter a note',
  },
  mainGlass: {
    [LANGUAGES.ru.code]: () => 'Базовое стекло',
    [LANGUAGES.en.code]: () => 'Base glass',
  },
  backToConfigurator: {
    [LANGUAGES.ru.code]: () => 'Назад в конфигуратор',
    [LANGUAGES.en.code]: () => 'Back to the configurator',
  },
  selectComponents: {
    [LANGUAGES.ru.code]: () => 'Выбрать компоненты',
    [LANGUAGES.en.code]: () => 'Select the components',
  },
  missingComponent: {
    [LANGUAGES.ru.code]: () => 'Компонент отсутствует',
    [LANGUAGES.en.code]: () => 'Missing component',
  },
  invalidHeatTreatment: {
    [LANGUAGES.ru.code]: () => 'Недопустимая термическая обработка',
    [LANGUAGES.en.code]: () => 'Invalid heat treatment',
  },
  invalidWidth: {
    [LANGUAGES.ru.code]: () => 'Увеличьте номинал стекла',
    [LANGUAGES.en.code]: () => 'Increase the glass width',
  },
  incompatibleCover: {
    [LANGUAGES.ru.code]: () => 'Несовместимое базовое стекло',
    [LANGUAGES.en.code]: () => 'Incompatible base glass',
  },
  maxGasCount: {
    [LANGUAGES.ru.code]: () => 'Максимум два газовых промежутка',
    [LANGUAGES.en.code]: () => 'Maximum two gas layers',
  },
  invalidPositionOutsideChamber: {
    [LANGUAGES.ru.code]: () => 'Недоп. вне камеры',
    [LANGUAGES.en.code]: () => 'Not all. outside cavity',
  },
  invalidPositionTowardsFilm: {
    [LANGUAGES.ru.code]: () => 'Недоп. к плёнке',
    [LANGUAGES.en.code]: () => 'Not all. facing film',
  },
  createNewProject: {
    [LANGUAGES.ru.code]: () => 'Создать новый проект',
    [LANGUAGES.en.code]: () => 'Create a new project',
  },
  showMore: {
    [LANGUAGES.ru.code]: () => 'Показать еще',
    [LANGUAGES.en.code]: () => 'Show more',
  },
  selected: {
    [LANGUAGES.ru.code]: () => 'Выбрано',
    [LANGUAGES.en.code]: () => 'Selected',
  },
  confHistory: {
    [LANGUAGES.ru.code]: () => 'Личный кабинет / История конфигураций',
    [LANGUAGES.en.code]: () => 'Personal account / Configuration history',
  },
  myProjectsSubTitle: {
    [LANGUAGES.ru.code]: () => 'Личный кабинет / Мои проекты',
    [LANGUAGES.en.code]: () => 'Personal account / My projects',
  },
  addToProject: {
    [LANGUAGES.ru.code]: () => 'Добавить в проект',
    [LANGUAGES.en.code]: () => 'Add to the project',
  },
  editConfiguration: {
    [LANGUAGES.ru.code]: () => 'Редактировать конфигурацию',
    [LANGUAGES.en.code]: () => 'Edit the configuration',
  },
  saveToPdf: {
    [LANGUAGES.ru.code]: () => 'Сохранить в pdf',
    [LANGUAGES.en.code]: () => 'Save to pdf',
  },
  saveToArchive: {
    [LANGUAGES.ru.code]: () => 'Сохранить в архив',
    [LANGUAGES.en.code]: () => 'Save to archive',
  },
  saveToDocx: {
    [LANGUAGES.ru.code]: () => 'Скачать таблицу',
    [LANGUAGES.en.code]: () => 'Download the table',
  },
  sendByEmail: {
    [LANGUAGES.ru.code]: () => 'Отправить по e-mail',
    [LANGUAGES.en.code]: () => 'Send by e-mail',
  },
  note: {
    [LANGUAGES.ru.code]: () => 'Примечание',
    [LANGUAGES.en.code]: () => 'Note',
  },
  clear: {
    [LANGUAGES.ru.code]: () => 'Очистить',
    [LANGUAGES.en.code]: () => 'Clear',
  },
  noteText: {
    [LANGUAGES.ru.code]: () => 'примечание',
    [LANGUAGES.en.code]: () => 'note',
  },
  mainCharacteristics: {
    [LANGUAGES.ru.code]: () => 'Основные характеристики',
    [LANGUAGES.en.code]: () => 'Main characteristics',
  },
  technicalCharacteristics: {
    [LANGUAGES.ru.code]: () => 'Моделирование технических характеристик',
    [LANGUAGES.en.code]: () => 'Modeling of technical characteristics',
  },
  footerDescription: {
    [LANGUAGES.ru.code]: () => 'Конфигуратор AIG – это инструмент моделирования, предоставляющий возможность расчета и анализа технических характеристик стеклоизделий из стекла производства компании AIG (здесь и далее под компанией AIG понимается ООО "КСЗ", ИНН 5020033028 и АО "БСЗ", ИНН 5246002261). Инструмент помогает пользователю всесторонне оценить показатели описанной в отчёте конфигурации стеклоизделия. Оценка расчетных параметров применима только к стёклам и стеклоизделиям из стекла производства компании AIG. Выполненный расчет конфигурации может содержать некоторые отклонения и не заменяет проектную документацию на светопрозрачные конструкции и заключения соответствующих специалистов, хотя компания AIG приложила все усилия для проверки надежности этого инструмента моделирования. Пользователь принимает на себя любые риски, связанные с использованием результатов, полученных с помощью Конфигуратора AIG, и самостоятельно несет ответственность за выбор конфигурации стекла под проект на основе расчёта в Конфигураторе AIG. Результаты расчёта характеристик стеклоизделий носят информационный характер и никоим образом не подразумевает приемку какого-либо заказа компанией AIG. Компания AIG не предоставляет какой-либо явной или подразумеваемой гарантии в отношении результатов применения Конфигуратора AIG. Ни при каких обстоятельствах компания AIG не несет ответственность за прямые, опосредованные, косвенные или случайные убытки, связанные с или возникшие в результате использования инструмента Конфигуратор AIG.',
    [LANGUAGES.en.code]: () => 'AIG Configurator is a modeling tool that provides the capability to calculate and analyze technical characteristics of glass products manufactured by AIG (hereinafter, AIG refers to "Klin Glassworks" LLC, TIN 5020033028 and "Bor Glassworks" JCS, TIN 5246002261). The tool helps the user to comprehensively assess the parameters of the glass product configuration described in the report. Evaluation of calculated parameters is applicable only to glass and glass products manufactured by AIG. The result of configuration calculation may contain some deviations and does not replace the design documentation for translucent structures or expertize, although AIG has made every effort to verify the reliability of this modeling tool. The user assumes any risks associated with the use of the results obtained using the AIG Configurator, and is independently responsible for choosing the glass configuration for the project based on the calculation in the AIG Configurator. The results of glass product characteristics calculations are for informational purposes only and in no way imply any order acceptance by AIG. AIG does not provide any express or implied warranty regarding the results of using the AIG Configurator. Under no circumstances shall AIG be liable for direct, indirect, consequential, or incidental damages related to or arising from the use of the AIG Configurator tool.',
  },
  components: {
    [LANGUAGES.ru.code]: (count) => getWordForm(count, WORD_FORMS.component),
    [LANGUAGES.en.code]: (count) => (count === 1 ? 'component' : 'components'),
  },
  delete: {
    [LANGUAGES.ru.code]: () => 'Удалить',
    [LANGUAGES.en.code]: () => 'Delete',
  },
  edit: {
    [LANGUAGES.ru.code]: () => 'Изменить',
    [LANGUAGES.en.code]: () => 'Edit',
  },
  add: {
    [LANGUAGES.ru.code]: () => 'Добавить',
    [LANGUAGES.en.code]: () => 'Add',
  },
  emptyListText: {
    [LANGUAGES.ru.code]: () => 'Перетащите компоненты для создания конфигурации',
    [LANGUAGES.en.code]: () => 'Drag components to create a configuration',
  },
  calculate: {
    [LANGUAGES.ru.code]: () => 'Рассчитать',
    [LANGUAGES.en.code]: () => 'Calculate',
  },
  configure: {
    [LANGUAGES.ru.code]: () => 'Сконфигурировать',
    [LANGUAGES.en.code]: () => 'Configure',
  },
  angleOfInclination: {
    [LANGUAGES.ru.code]: () => 'Угол наклона',
    [LANGUAGES.en.code]: () => 'Tilt angle',
  },
  glassType: {
    [LANGUAGES.ru.code]: () => 'Тип стекла',
    [LANGUAGES.en.code]: () => 'Glass type',
  },
  setConfiguration: {
    [LANGUAGES.ru.code]: () => 'Введите конфигурацию',
    [LANGUAGES.en.code]: () => 'Enter the configuration',
  },
  configuratorTemplatesTitle: {
    [LANGUAGES.ru.code]: () => 'Выберите шаблон конфигурации ниже или добавьте компоненты вручную',
    [LANGUAGES.en.code]: () => 'Select the configuration template below or add the components manually',
  },
  city: {
    [LANGUAGES.ru.code]: () => 'Город',
    [LANGUAGES.en.code]: () => 'City',
  },
  refreshConfiguration: {
    [LANGUAGES.ru.code]: () => 'Сбросить конфигурацию',
    [LANGUAGES.en.code]: () => 'Reset the configuration',
  },
  emptyText: {
    [LANGUAGES.ru.code]: () => 'Пусто.',
    [LANGUAGES.en.code]: () => 'Empty.',
  },
  watchVideo: {
    [LANGUAGES.ru.code]: () => 'Смотреть видео-инструкцию по работе',
    [LANGUAGES.en.code]: () => 'Watch the video tutorial',
  },
  configInstructionsTitle: {
    [LANGUAGES.ru.code]: () => 'Инструкция по работе с конфигуратором',
    [LANGUAGES.en.code]: () => 'Tutorial',
  },
  configInstructionsSubTitle: {
    [LANGUAGES.ru.code]: () => 'Главная / Инструкция',
    [LANGUAGES.en.code]: () => 'Home / Instructions',
  },
  configInstructionsDescription: {
    [LANGUAGES.ru.code]: () => 'Создайте первую конфигурацию прямо сейчас: зарегистрируйтесь и перейдите в конфигуратор в режиме обучения.',
    [LANGUAGES.en.code]: () => 'Create your first configuration right now: register and go to the configurator in training mode.',
  },
  restore: {
    [LANGUAGES.ru.code]: () => 'Восстановить',
    [LANGUAGES.en.code]: () => 'Recover',
  },
  passwordFormTitle: {
    [LANGUAGES.ru.code]: () => 'Восстановление пароля',
    [LANGUAGES.en.code]: () => 'Password recovery',
  },
  passwordFormSubTitle: {
    [LANGUAGES.ru.code]: () => 'Главная / Восстановление пароля',
    [LANGUAGES.en.code]: () => 'Home / Password recovery',
  },
  contactFormSubTitle: {
    [LANGUAGES.ru.code]: () => 'Главная / Связаться с нами',
    [LANGUAGES.en.code]: () => 'Home / Contact us',
  },
  enterPasswordFormTitle: {
    [LANGUAGES.ru.code]: () => 'Введите новый пароль',
    [LANGUAGES.en.code]: () => 'Enter new password',
  },
  agreePrivacyPolicy: {
    [LANGUAGES.ru.code]: () => 'Я согласен с политикой конфиденциальности',
    [LANGUAGES.en.code]: () => 'I agree with the privacy policy',
  },
  authFormTitle: {
    [LANGUAGES.ru.code]: () => 'Авторизация',
    [LANGUAGES.en.code]: () => 'Log in',
  },
  authFormSubTitle: {
    [LANGUAGES.ru.code]: () => 'Главная / Авторизация',
    [LANGUAGES.en.code]: () => 'Home / Log in',
  },
  registerFormSubTitle: {
    [LANGUAGES.ru.code]: () => 'Главная / Регистрация',
    [LANGUAGES.en.code]: () => 'Home / Registration',
  },
  forgotPasswordLink: {
    [LANGUAGES.ru.code]: () => 'Забыли пароль?',
    [LANGUAGES.en.code]: () => 'Forgot password?',
  },
  personalTitle: {
    [LANGUAGES.ru.code]: () => 'Личные данные',
    [LANGUAGES.en.code]: () => 'Personal Data',
  },
  personalSubTitle: {
    [LANGUAGES.ru.code]: () => 'Личный кабинет / Личные данные',
    [LANGUAGES.en.code]: () => 'Personal account / Personal data',
  },
  fullName: {
    [LANGUAGES.ru.code]: () => 'ФИО',
    [LANGUAGES.en.code]: () => 'Full name',
  },
  phone: {
    [LANGUAGES.ru.code]: () => 'Телефон',
    [LANGUAGES.en.code]: () => 'Phone number',
  },
  companyName: {
    [LANGUAGES.ru.code]: () => 'Название компании',
    [LANGUAGES.en.code]: () => 'Company name',
  },
  company: {
    [LANGUAGES.ru.code]: () => 'Компания',
    [LANGUAGES.en.code]: () => 'Company',
  },
  position: {
    [LANGUAGES.ru.code]: () => 'Должность',
    [LANGUAGES.en.code]: () => 'Profession',
  },
  newPassword: {
    [LANGUAGES.ru.code]: () => 'Новый пароль',
    [LANGUAGES.en.code]: () => 'New password',
  },
  confirmPassword: {
    [LANGUAGES.ru.code]: () => 'Подтверждение пароля ',
    [LANGUAGES.en.code]: () => 'Confirm password',
  },
  passwordInputLabel: {
    [LANGUAGES.ru.code]: () => 'Пароль',
    [LANGUAGES.en.code]: () => 'Password',
  },
  repeatPasswordInputLabel: {
    [LANGUAGES.ru.code]: () => 'Повторите пароль',
    [LANGUAGES.en.code]: () => 'Repeat password',
  },
  confirmNewPassword: {
    [LANGUAGES.ru.code]: () => 'Подтверждение нового пароля',
    [LANGUAGES.en.code]: () => 'Confirm new password',
  },
  saveChanges: {
    [LANGUAGES.ru.code]: () => 'Сохранить изменения',
    [LANGUAGES.en.code]: () => 'Save changes',
  },
  rememberMeCheckbox: {
    [LANGUAGES.ru.code]: () => 'Запомнить',
    [LANGUAGES.en.code]: () => 'Remember me',
  },
  privacyTitle: {
    [LANGUAGES.ru.code]: () => 'Политика конфиденциальности',
    [LANGUAGES.en.code]: () => 'Privacy Policy',
  },
  privacySubTitle: {
    [LANGUAGES.ru.code]: () => 'Главная / Политика конфиденциальности',
    [LANGUAGES.en.code]: () => 'Home / Privacy Policy',
  },
  formTitle: {
    [LANGUAGES.ru.code]: () => 'Остались вопросы?',
    [LANGUAGES.en.code]: () => 'Any questions left?',
  },
  nameInputLabel: {
    [LANGUAGES.ru.code]: () => 'ФИО',
    [LANGUAGES.en.code]: () => 'Full name',
  },
  emailInputLabel: {
    [LANGUAGES.ru.code]: () => 'E-mail',
    [LANGUAGES.en.code]: () => 'E-mail',
  },
  topicInputLabel: {
    [LANGUAGES.ru.code]: () => 'Тема',
    [LANGUAGES.en.code]: () => 'Topic',
  },
  topicInputPlaceholder: {
    [LANGUAGES.ru.code]: () => 'Выберите тему',
    [LANGUAGES.en.code]: () => 'Select a Topic',
  },
  requestInputLabel: {
    [LANGUAGES.ru.code]: () => 'Ваш запрос',
    [LANGUAGES.en.code]: () => 'Your Request',
  },
  privacyPolicyCheckbox: {
    [LANGUAGES.ru.code]: () => 'Я даю согласие на обработку персональных данных',
    [LANGUAGES.en.code]: () => 'I consent to the processing of personal data',
  },
  submitButtonText: {
    [LANGUAGES.ru.code]: () => 'Отправить сообщение',
    [LANGUAGES.en.code]: () => 'Send Message',
  },
  errorMessages: {
    required: {
      [LANGUAGES.ru.code]: () => 'Выбери',
      [LANGUAGES.en.code]: () => 'Please select',
    },
  },
  instructionMainTitle: {
    [LANGUAGES.ru.code]: () => 'Подробная инструкция по работе',
    [LANGUAGES.en.code]: () => 'Detailed instruction',
  },
  instructionMainDescription: {
    [LANGUAGES.ru.code]: () => 'Посмотрите видео-инструкцию',
    [LANGUAGES.en.code]: () => 'Watch the video tutorial',
  },
  watchVideoInstructionButton: {
    [LANGUAGES.ru.code]: () => 'Смотреть видео-инструкцию',
    [LANGUAGES.en.code]: () => 'Watch the video tutorial',
  },
  stepOneTitle: {
    [LANGUAGES.ru.code]: () => 'Создайте конфигурацию',
    [LANGUAGES.en.code]: () => 'Create the configuration',
  },
  stepOneDescription: {
    [LANGUAGES.ru.code]: () => 'Задайте конфигурацию с помощью готового шаблона, специального скретч-кода или выберите элементы вручную',
    [LANGUAGES.en.code]: () => 'Set the configuration using a template, a special script code or select elements manually',
  },
  stepTwoTitle: {
    [LANGUAGES.ru.code]: () => 'Рассчитайте характеристики стеклоизделий',
    [LANGUAGES.en.code]: () => 'Calculate the characteristics of glass products',
  },
  stepTwoDescription: {
    [LANGUAGES.ru.code]: () => 'Получите подробный расчет технических характеристик',
    [LANGUAGES.en.code]: () => 'Get a detailed calculation of technical characteristics',
  },
  stepThreeTitle: {
    [LANGUAGES.ru.code]: () => 'Проанализируйте и сохраните результаты расчета',
    [LANGUAGES.en.code]: () => 'Analyze and save the calculation results',
  },
  stepThreeDescription: {
    [LANGUAGES.ru.code]: () => 'Сохраните результаты расчета в pdf, перешлите их на e-mail или сохраните в разделе "Мои проекты"',
    [LANGUAGES.en.code]: () => 'Save the calculation results as a pdf, forward them by e-mail, or save them to "My projects"',
  },
  whatIsTitle: {
    [LANGUAGES.ru.code]: () => 'Что такое конфигуратор AIG?',
    [LANGUAGES.en.code]: () => 'About AIG configurator',
  },
  whatIsDescription1: {
    [LANGUAGES.ru.code]: () => 'Конфигуратор AIG — это онлайн-инструмент, который позволяет быстро и точно рассчитать технические параметры стеклоизделия, а также подобрать конфигурацию, соответствующую концепции проекта и заявленным требованиям.',
    [LANGUAGES.en.code]: () => 'Configurator AIG is an online tool that allows you to quickly and accurately calculate the technical parameters of glass products and select a configuration that matches the project concept and stated requirements.',
  },
  whatIsDescription2: {
    [LANGUAGES.ru.code]: () => 'Задайте необходимую конфигурацию (количество камер, типы и номиналы стекол, покрытия и газовые промежутки) и получите подробный расчет оптических, энергетических, теплофизических и иных характеристик стеклоизделий в соответствии с актуальными нормативами РФ.',
    [LANGUAGES.en.code]: () => 'Put the required configuration (number, thicknesses, types of glass, coatings and gas gaps) and get a detailed calculation of the light, energy, thermal and other characteristics of the glass products in accordance with the current Russian standards.',
  },
  whatIsDescription3: {
    [LANGUAGES.ru.code]: () => 'С помощью Конфигуратора AIG Вы сможете получить технические характеристики стеклоизделий в режиме реального времени: создайте несколько конфигураций, проанализируйте данные и выберите идеальное решение под Ваши задачи.',
    [LANGUAGES.en.code]: () => 'With AIG Configurator you can get the technical characteristics of glass products online by creating multiple configurations, analyzing the data and choosing the perfect solution to meet your requirements.',
  },
  moreAboutConfiguratorButton: {
    [LANGUAGES.ru.code]: () => 'Подробнее о Конфигураторе AIG',
    [LANGUAGES.en.code]: () => 'More about AIG Сonfigurator',
  },
  homeCreateTitle: {
    [LANGUAGES.ru.code]: () => 'Создайте уникальную конфигурацию стеклоизделия онлайн',
    [LANGUAGES.en.code]: () => 'Create a unique glass product configuration online',
  },
  configuratorFeatureTitle: {
    [LANGUAGES.ru.code]: () => 'Удобный визуальный онлайн-конфигуратор',
    [LANGUAGES.en.code]: () => 'User-friendly visual online configurator',
  },
  configuratorFeatureDescription: {
    [LANGUAGES.ru.code]: () => 'соберите композицию стеклоизделия под Ваши требования за несколько шагов',
    [LANGUAGES.en.code]: () => 'make a glass product composition to your requirements with a few steps',
  },
  calculatorFeatureTitle: {
    [LANGUAGES.ru.code]: () => 'Подробный расчет технических характеристик',
    [LANGUAGES.en.code]: () => 'Detailed calculation of the technical characteristics',
  },
  calculatorFeatureDescription: {
    [LANGUAGES.ru.code]: () => 'все необходимые характеристики в одном файле',
    [LANGUAGES.en.code]: () => 'all required characteristics in one file',
  },
  downloadFeatureTitle: {
    [LANGUAGES.ru.code]: () => 'Выгрузка результатов в удобном формате',
    [LANGUAGES.en.code]: () => 'Export results in handy format',
  },
  downloadFeatureDescription: {
    [LANGUAGES.ru.code]: () => 'сохраните расчеты в личном кабинете, скачайте в формате pdf или отправьте на e-mail',
    [LANGUAGES.en.code]: () => 'save calculation results in your personal account, download in pdf, or send by e-mail',
  },
  createConfigurationButton: {
    [LANGUAGES.ru.code]: () => 'Создать конфигурацию',
    [LANGUAGES.en.code]: () => 'Create the configuration',
  },

  policy1Title: {
    [LANGUAGES.ru.code]: () => '1. Общие положения',
    [LANGUAGES.en.code]: () => '1. General provisions',
  },
  policy1_1: {
    [LANGUAGES.ru.code]: () => '1.1. Настоящая Политика конфиденциальности регулирует обработку и защиту персональных данных пользователей, которые были предоставлены при использовании сайта [название сайта] (далее — Сайт).',
    [LANGUAGES.en.code]: () => '1.1. This Privacy Policy governs the processing and protection of personal data of users that were provided when using the website [website name] (hereinafter referred to as the Website).',
  },
  policy1_2: {
    [LANGUAGES.ru.code]: () => '1.2. Под персональными данными понимается любая информация, которая прямо или косвенно относится к определенному физическому лицу (субъекту персональных данных).',
    [LANGUAGES.en.code]: () => '1.2. Personal data is understood as any information that directly or indirectly relates to a specific individual (personal data subject).',
  },
  policy1_3: {
    [LANGUAGES.ru.code]: () => '1.3. Пользователь, предоставляя свои персональные данные, соглашается с условиями настоящей Политики конфиденциальности.',
    [LANGUAGES.en.code]: () => '1.3. By providing their personal data, the User agrees to the terms of this Privacy Policy.',
  },

  policy2Title: {
    [LANGUAGES.ru.code]: () => '2. Цели обработки персональных данных',
    [LANGUAGES.en.code]: () => '2. Purposes of personal data processing',
  },
  policy2_1: {
    [LANGUAGES.ru.code]: () => '2.1. Обработка персональных данных осуществляется для следующих целей:',
    [LANGUAGES.en.code]: () => '2.1. Personal data processing is carried out for the following purposes:',
  },
  policy2_1_purposes: {
    [LANGUAGES.ru.code]: () => [
      '- Предоставление доступа к функционалу Сайта <br />',
      '- Улучшение качества обслуживания и работы Сайта <br />',
      '- Обработка запросов пользователей и обратной связи <br />',
      '- Направление уведомлений и информационных материалов (при согласии пользователя) <br />',
    ],
    [LANGUAGES.en.code]: () => [
      '- Providing access to the Website functionality <br /> ',
      '- Improving service quality and Website performance <br />',
      '- Processing user requests and feedback <br />',
      '- Sending notifications and informational materials (with user consent) <br />',
    ],
  },

  policy3Title: {
    [LANGUAGES.ru.code]: () => '3. Перечень собираемых данных',
    [LANGUAGES.en.code]: () => '3. List of collected data',
  },
  policy3_1: {
    [LANGUAGES.ru.code]: () => '3.1. При использовании Сайта могут собираться следующие данные:',
    [LANGUAGES.en.code]: () => '3.1. The following data may be collected when using the Website:',
  },
  policy3_1_data: {
    [LANGUAGES.ru.code]: () => [
      '- Личные данные (ФИО, адрес электронной почты, номер телефона)<br />',
      '-Данные, автоматически передаваемые при использовании Сайта (IP-адрес, информация о браузере, файлы cookie)<br />',
    ],
    [LANGUAGES.en.code]: () => [
      '- Personal data (full name, email address, phone number)<br />',
      '- Data automatically transmitted when using the Website (IP address, browser information, cookies)<br />',
    ],
  },

  policy4Title: {
    [LANGUAGES.ru.code]: () => '4. Условия обработки персональных данных',
    [LANGUAGES.en.code]: () => '4. Personal data processing conditions',
  },
  policy4_1: {
    [LANGUAGES.ru.code]: () => '4.1. Обработка персональных данных осуществляется в соответствии с законодательством [ваша страна].',
    [LANGUAGES.en.code]: () => '4.1. Personal data processing is carried out in accordance with the legislation of [your country].',
  },
  policy4_2: {
    [LANGUAGES.ru.code]: () => '4.2. Сайт не передает персональные данные пользователей третьим лицам без их согласия, за исключением случаев, предусмотренных законодательством.',
    [LANGUAGES.en.code]: () => '4.2. The Website does not transfer users  personal data to third parties without their consent, except in cases provided for by law.',
  },
  policy4_3: {
    [LANGUAGES.ru.code]: () => '4.3. Пользователь может в любой момент отозвать свое согласие на обработку персональных данных, направив соответствующий запрос администрации Сайта.',
    [LANGUAGES.en.code]: () => '4.3. The User can revoke their consent to personal data processing at any time by sending a corresponding request to the Website administration.',
  },

  policy5Title: {
    [LANGUAGES.ru.code]: () => '5. Меры по защите персональных данных',
    [LANGUAGES.en.code]: () => '5. Personal data protection measures',
  },
  policy5_1: {
    [LANGUAGES.ru.code]: () => '5.1. Администрация Сайта принимает необходимые организационные и технические меры для защиты персональных данных пользователей от неправомерного доступа, утраты, уничтожения, изменения или разглашения.',
    [LANGUAGES.en.code]: () => '5.1. The Website administration takes necessary organizational and technical measures to protect users\' personal data from unauthorized access, loss, destruction, alteration, or disclosure.',
  },

  policy6Title: {
    [LANGUAGES.ru.code]: () => '6. Файлы cookie',
    [LANGUAGES.en.code]: () => '6. Cookies',
  },
  policy6_1: {
    [LANGUAGES.ru.code]: () => '6.1. Сайт использует файлы cookie для обеспечения его корректной работы, улучшения пользовательского опыта и анализа поведения пользователей.',
    [LANGUAGES.en.code]: () => '6.1. The Website uses cookies to ensure its correct operation, improve user experience, and analyze user behavior.',
  },
  policy6_2: {
    [LANGUAGES.ru.code]: () => '6.2. Пользователь может отключить файлы cookie в настройках браузера, однако это может повлиять на функциональность Сайта.',
    [LANGUAGES.en.code]: () => '6.2. The User can disable cookies in their browser settings, however, this may affect the Website\'s functionality.',
  },

  policy7Title: {
    [LANGUAGES.ru.code]: () => '7. Изменения в Политике конфиденциальности',
    [LANGUAGES.en.code]: () => '7. Changes to Privacy Policy',
  },
  policy7_1: {
    [LANGUAGES.ru.code]: () => '7.1. Администрация Сайта оставляет за собой право изменять настоящую Политику конфиденциальности.',
    [LANGUAGES.en.code]: () => '7.1. The Website administration reserves the right to modify this Privacy Policy.',
  },
  policy7_2: {
    [LANGUAGES.ru.code]: () => '7.2. Новая редакция Политики вступает в силу с момента ее размещения на Сайте, если иное не предусмотрено новой редакцией.',
    [LANGUAGES.en.code]: () => '7.2. The new version of the Policy becomes effective from the moment of its placement on the Website, unless otherwise provided by the new version.',
  },

  policy8Title: {
    [LANGUAGES.ru.code]: () => '8. Контактная информация',
    [LANGUAGES.en.code]: () => '8. Contact information',
  },
  policy8_1: {
    [LANGUAGES.ru.code]: () => '8.1. По вопросам, связанным с Политикой конфиденциальности, пользователь может обратиться к администрации Сайта по адресу электронной почты: [email@example.com].',
    [LANGUAGES.en.code]: () => '8.1. For questions related to the Privacy Policy, the User can contact the Website administration at the email address: [email@example.com].',
  },

  policy9Title: {
    [LANGUAGES.ru.code]: () => '9. Согласие на обработку данных',
    [LANGUAGES.en.code]: () => '9. Consent to data processing',
  },
  policy9_1: {
    [LANGUAGES.ru.code]: () => '9.1. Продолжая использовать Сайт, пользователь подтверждает свое согласие с условиями настоящей Политики конфиденциальности.',
    [LANGUAGES.en.code]: () => '9.1. By continuing to use the Website, the User confirms their agreement with the terms of this Privacy Policy.',
  },

  empty: {
    [LANGUAGES.ru.code]: () => 'Пусто.',
    [LANGUAGES.en.code]: () => 'Not found.',
  },
  configurationsHistory: {
    [LANGUAGES.ru.code]: () => 'История конфигураций',
    [LANGUAGES.en.code]: () => 'Configuration history',
  },
  logout: {
    [LANGUAGES.ru.code]: () => 'Выйти',
    [LANGUAGES.en.code]: () => 'Log out',
  },
  myProjects: {
    [LANGUAGES.ru.code]: () => 'Мои проекты',
    [LANGUAGES.en.code]: () => 'My projects',
  },
  weInSocials: {
    [LANGUAGES.ru.code]: () => 'Мы в социальных сетях',
    [LANGUAGES.en.code]: () => 'Find us on social media',
  },
  toAigWeb: {
    [LANGUAGES.ru.code]: () => 'На сайт AIG',
    [LANGUAGES.en.code]: () => 'To AIG website',
  },
  policy1: {
    [LANGUAGES.ru.code]: () => '© AIG 2025. Все права защищены',
    [LANGUAGES.en.code]: () => '© AIG 2025. All rights reserved',
  },
  policy2: {
    [LANGUAGES.ru.code]: () => 'Политика в отношении обработки персональных данных',
    [LANGUAGES.en.code]: () => 'Personal data processing policy',
  },
  configurator: {
    [LANGUAGES.ru.code]: () => 'Конфигуратор',
    [LANGUAGES.en.code]: () => 'Configurator',
  },
  instructions: {
    [LANGUAGES.ru.code]: () => 'Инструкция',
    [LANGUAGES.en.code]: () => 'Instructions',
  },
  contactUs: {
    [LANGUAGES.ru.code]: () => 'Связаться с нами',
    [LANGUAGES.en.code]: () => 'Contact us',
  },
  personalAccount: {
    [LANGUAGES.ru.code]: () => 'Личный кабинет',
    [LANGUAGES.en.code]: () => 'Personal account',
  },
  personalData: {
    [LANGUAGES.ru.code]: () => 'Личные данные',
    [LANGUAGES.en.code]: () => 'Personal data',
  },
  aboutConfigurator: {
    [LANGUAGES.ru.code]: () => 'О Конфигураторе AIG',
    [LANGUAGES.en.code]: () => 'About AIG Сonfigurator',
  },
  registration: {
    [LANGUAGES.ru.code]: () => 'Регистрация',
    [LANGUAGES.en.code]: () => 'Registration',
  },
  register: {
    [LANGUAGES.ru.code]: () => 'Зарегистрироваться',
    [LANGUAGES.en.code]: () => 'Registration',
  },
  toLogin: {
    [LANGUAGES.ru.code]: () => 'Вход',
    [LANGUAGES.en.code]: () => 'Log in',
  },
  login: {
    [LANGUAGES.ru.code]: () => 'Войти',
    [LANGUAGES.en.code]: () => 'Log in',
  },
  personalDataAgreement: {
    title1: {
      [LANGUAGES.ru.code]: () => 'СОГЛАСИЕ',
      [LANGUAGES.en.code]: () => 'CONSENT',
    },
    title2: {
      [LANGUAGES.ru.code]: () => 'на обработку персональных данных пользователя Веб-приложения Конфигуратор AIG (gc.aigrus.ru)',
      [LANGUAGES.en.code]: () => 'to the personal data processing',
    },

    section1_title: {},
    section1_1: {
      [LANGUAGES.ru.code]: () => '<b>Я, пользователь Веб-приложения Конфигуратор AIG</b> (далее – «Субъект», «Сайт»), выражаю конкретное, предметное, информированное, сознательное и однозначное согласие на обработку моих персональных данных ООО «КСЗ» (далее – «Оператор») на условиях, указанных ниже.',
      [LANGUAGES.en.code]: () => '<b>I, the user of the AIG Configurator Web Application</b> (hereinafter referred to as the «Subject», «Website»), express specific, substantive, informed, conscious and unequivocal consent to the processing of my personal data by KSZ LLC (hereinafter referred to as the "Operator") on the terms specified below.',
    },

    section2_title: {
      [LANGUAGES.ru.code]: () => 'Сведения об Операторе',
      [LANGUAGES.en.code]: () => 'Information about the Operator',
    },
    section2_1: {
      [LANGUAGES.ru.code]: () => 'Общество с ограниченной ответственностью «Клинский стекольный завод» (ООО «КСЗ»)',
      [LANGUAGES.en.code]: () => '«Klin Glassworks» Limited liability company (KGW LLC)',
    },
    section2_2: {
      [LANGUAGES.ru.code]: () => 'ИНН 5020033028, ОГРН 1035003950321',
      [LANGUAGES.en.code]: () => 'TIN 5020033028, OGRN 1035003950321',
    },
    section2_3: {
      [LANGUAGES.ru.code]: () => 'Адрес: 141667, Московская область, г. Клин, с. Спас-Заулок, Сосновый бор, 36',
      [LANGUAGES.en.code]: () => 'Address: 36 Sosnovy Bor, Spas-Zaulok village, Klin, Moscow region, 141667',
    },
    section2_4: {
      [LANGUAGES.ru.code]: () => 'Адрес электронной почты: info@aigrus.ru',
      [LANGUAGES.en.code]: () => 'Email address: info@aigrus.ru',
    },

    section3_title: {
      [LANGUAGES.ru.code]: () => 'Цель обработки персональных данных',
      [LANGUAGES.en.code]: () => 'Purpose of personal data processing',
    },
    section3_1: {
      [LANGUAGES.ru.code]: () => 'Предоставление доступа к сайту, его содержанию, к функционалу сервиса, для администрирования Сайта; идентификация при регистрации и/или использовании Сайта; предложение Субъекту товаров и услуг Оператора (строительное стекло, изделия из стекла, соответствующие консультационные услуги), а также предоставление Субъекту дополнительной информации, связанной с данными товарами и услугами.',
      [LANGUAGES.en.code]: () => 'Providing of access to the Website, its content, and service functionality for the Website administration; identification during registration and/ or use of the Website; offering the Operator\'s goods and services to the Subject (construction glass, glass products, related consulting services), as well as providing the Subject with additional information related to these goods and services.',
    },

    section4_title: {
      [LANGUAGES.ru.code]: () => 'Категории (перечень) обрабатываемых персональных данных',
      [LANGUAGES.en.code]: () => 'Categories (list) of processed personal data',
    },
    section4_1: {
      [LANGUAGES.ru.code]: () => 'Персональные данные, не относящиеся к специальным категориям, а именно:',
      [LANGUAGES.en.code]: () => 'Personal data that does not belong to special categories, namely: ',
    },
    section4_2: {
      [LANGUAGES.ru.code]: () => '1. Фамилия, имя, отчество.',
      [LANGUAGES.en.code]: () => '1. Last name, first name, patronymic. ',
    },
    section4_3: {
      [LANGUAGES.ru.code]: () => '2. Номер телефона.',
      [LANGUAGES.en.code]: () => '2. Phone number.',
    },
    section4_4: {
      [LANGUAGES.ru.code]: () => '3. Адрес электронной почты.',
      [LANGUAGES.en.code]: () => '3. Email address.',
    },
    section4_5: {
      [LANGUAGES.ru.code]: () => '4. Наименование компании-работодателя.',
      [LANGUAGES.en.code]: () => '4. The name of the employing company.',
    },
    section4_6: {
      [LANGUAGES.ru.code]: () => '5. Занимаемая должность, вид профессиональной деятельности.',
      [LANGUAGES.en.code]: () => '5. Current position, type of professional activity.',
    },
    section4_7: {
      [LANGUAGES.ru.code]: () => '6. Город пребывания (по месту работы).',
      [LANGUAGES.en.code]: () => '6. The city of residence (at the place of work).',
    },
    section4_8: {
      [LANGUAGES.ru.code]: () => '7. Данные, которые автоматически передаются в процессе просмотра и при посещении страниц Сайта (cookie-файлы), а именно: дата и время доступа, адрес посещаемой страницы, источник выхода, реферер (адрес предыдущей страницы), информация о поведении (включая количество и наименование просмотренных страниц), прочие технические данные (данные о технических средствах (в том числе мобильных устройствах) и способах технологического взаимодействия с Сайтом и его сервисами (в том числе вид операционной системы Пользователя, тип браузера, географическое положение, данные о провайдере и иное), об активности Пользователя при использовании Сайта, об информации об ошибках, выдаваемых Пользователю, о скачанных файлах, инструментах, а также иные данные, получаемые установленными настоящим согласием способами;',
      [LANGUAGES.en.code]: () => '7. Data that are automatically transmitted during the process of browsing and visiting the Website pages (cookie files), namely: date and time of access, the address of the visited page, the source of the output, the referrer (the address of the previous page), information about behavior (including the number and name of the pages viewed), other technical data (data on technical means (including mobile devices) and methods of technological interaction with the Website and its services (including the type of User\'s operating system, browser type, geographical location, provider information, and others), about the User\'s activity when using the Website, about error information provided to the User, about downloaded files, tools, as well as other data obtained by the methods established by this consent;',
    },
    section4_9: {
      [LANGUAGES.ru.code]: () => '8. IP-адрес и статистика об IP-адресах.',
      [LANGUAGES.en.code]: () => '8. IP address and statistics about IP addresses.',
    },

    section5_title: {
      [LANGUAGES.ru.code]: () => 'Перечень действий с персональными данными (способы обработки персональных данных)',
      [LANGUAGES.en.code]: () => 'List of actions with personal data (methods of personal data processing)',
    },
    section5_1: {
      [LANGUAGES.ru.code]: () => '1. Сбор, запись, накопление.',
      [LANGUAGES.en.code]: () => '1. Collection, recording, accumulation. ',
    },
    section5_2: {
      [LANGUAGES.ru.code]: () => '2. Просмотр (обращение), извлечение, использование.',
      [LANGUAGES.en.code]: () => '2. Viewing (handling), extraction, and use. ',
    },
    section5_3: {
      [LANGUAGES.ru.code]: () => '3. Хранение, уточнение (обновление, изменение), систематизация.',
      [LANGUAGES.en.code]: () => '3. Storage, refinement (updating, modification), systematization. ',
    },
    section5_4: {
      [LANGUAGES.ru.code]: () => '4. Обезличивание, блокирование, удаление, восстановление.',
      [LANGUAGES.en.code]: () => '4. Depersonalization, blocking, deletion, recovery. ',
    },
    section5_5: {
      [LANGUAGES.ru.code]: () => '5. Передача (предоставление) третьему лицу (ООО «Дженисофт» ИНН: 7723723276, 109044 Российская Федерация, г. Москва, вн.тер.г. муниципальный округ Южнопортовый, Крутицкий вал, д. 3, кв. 488) ), которое оказывает Оператору услуги по хостингу  и техническому обслуживанию Сайта.',
      [LANGUAGES.en.code]: () => '5. Conveyance to third parties (Genisoft LLC TIN: 7723723276, 109044 Russian Federation, Yuzhnoportovy municipal district, Krutitsky val, 3, sq. 488)), which provides hosting and Website maintenance services to the Operator.',
    },

    section6_title: {
      [LANGUAGES.ru.code]: () => 'Способы хранения персональных данных',
      [LANGUAGES.en.code]: () => 'Methods of personal data storage',
    },
    section6_1: {
      [LANGUAGES.ru.code]: () => 'Персональные данные хранятся в электронной форме в базе данных, локализованной на территории Российской Федерации.',
      [LANGUAGES.en.code]: () => 'Personal data is stored in electronic form in a database located on the territory of the Russian Federation.',
    },

    section7_title: {
      [LANGUAGES.ru.code]: () => 'Сроки обработки и хранения персональных данных (срок, в течение которого действует согласие Субъекта)',
      [LANGUAGES.en.code]: () => 'Terms of processing and storage of personal data (the period during which the consent of the Subject is valid)',
    },
    section7_1: {
      [LANGUAGES.ru.code]: () => '5 лет со дня получения согласия на обработку персональных данных.',
      [LANGUAGES.en.code]: () => '5 years from the date of obtaining consent to the processing of personal data.',
    },

    section8_title: {
      [LANGUAGES.ru.code]: () => 'Способ отзыва согласия и порядок уничтожения персональных данных',
      [LANGUAGES.en.code]: () => 'The method of revocation of consent and the procedure for the destruction of personal data',
    },
    section8_1: {
      [LANGUAGES.ru.code]: () => 'Согласие может быть отозвано Субъектом путем направления письменного уведомления Оператору по почтовому или электронному адресу. Персональные данные уничтожаются в течение 30 дней со дня истечения срока обработки или отзыва согласия путем удаления из базы данных.',
      [LANGUAGES.en.code]: () => 'The consent may be revoked by the Subject by sending a written notification to the Operator via postal or email address. Personal data is destroyed within 30 days from the date of expiration of the processing Terms or withdrawal of consent by deletion from the database.',
    },

    section9_title: {},
    section9_1: {
      [LANGUAGES.ru.code]: () => 'Субъекту также предоставлена возможность ознакомиться с Политикой в отношении обработки персональных данных Оператора.',
      [LANGUAGES.en.code]: () => 'The subject is also given the opportunity to familiarize themselves with the Policy regarding the processing of personal data of the Operator.',
    },
  },
};
